import React, { ChangeEvent, FormEvent } from "react"

import { Box } from "@mui/system"
import { Typography } from "@mui/material"
import { BSBuilding } from "../../../../../../../../../core/dto/beem-shot/BSBuilding/BSBuilding"
import { BSBuildingUpdateDto } from "../../../../../../../../../core/dto/beem-shot/BSBuilding/BSBuildingUpdateDto"
import { FormTextInput } from "../../../../../../../../../components/inputs/text-input/FormTextInput"
import { FormMultilineTextInput } from "../../../../../../../../../components/inputs/text-input/FormMultilineTextInput"
import { customPalette } from "../../../../../../../../../../theme"

export interface IBSBuildingNameDescriptionForm {
  name: string
  description: string
}

export function bsBuildingNameDescriptionFormToUpdateDto(
  form: IBSBuildingNameDescriptionForm,
  bsBuildingId: string
): BSBuildingUpdateDto {
  return {
    id: bsBuildingId,
    name: form.name,
    description: form.description,
  }
}

export function bsBuildingNameDescriptionDtoToForm(dto: BSBuilding | undefined): IBSBuildingNameDescriptionForm {
  return dto
    ? {
        name: dto.name,
        description: dto.description,
      }
    : ({ name: "", description: "" } as IBSBuildingNameDescriptionForm)
}

interface IProps {
  formId: string
  form: IBSBuildingNameDescriptionForm
  errors: Record<string, string | undefined>

  handleChange(event: ChangeEvent<HTMLInputElement>): void
  handleSubmit(event?: FormEvent<HTMLFormElement> | FormEvent<HTMLDivElement>, shouldResetForm?: boolean): Promise<void>
}

export function BSBuildingInfosForm({
  formId,
  form,
  errors,
  handleChange,
  handleSubmit,
}: Readonly<IProps>): React.JSX.Element {
  return (
    <Box
      id={formId}
      onSubmit={handleSubmit}
      component="form"
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}>
      <Typography variant="body1" fontWeight={600} sx={{ color: customPalette.darkBlue2 }}>
        Nom
      </Typography>
      <Box sx={{ mb: 1 }}>
        <FormTextInput fieldName="name" label="Nom" form={form} handleChange={handleChange} errors={errors} />
      </Box>

      <Typography variant="body1" fontWeight={600} sx={{ color: customPalette.darkBlue2 }}>
        Commentaire
      </Typography>
      <Typography variant="body2">Décrivez votre bâtiment</Typography>

      <FormMultilineTextInput
        fieldName="description"
        label="Description"
        required={false}
        form={form}
        errors={errors}
        handleChange={handleChange}
      />
    </Box>
  )
}
